import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useModalActions } from 'providers/ModalProvider'
import { Transition } from '@headlessui/react'
import { useDispatch, useSelector } from 'react-redux'
import { messagesSelectors } from 'store/messages'
import { settingsActions, settingsSelectors } from 'store/settings'
import { ChatBotAvatar } from 'components/chats/ChatBotAvatar'
import { UIButton } from 'components/ui/Button'
import { useIsAuthModeNoLogin } from 'hooks/useAuthMode'

export const TicketReminderCard = () => {
  const { t } = useTranslation()
  const { showOpenTicket } = useModalActions()
  const ticketReminderVisible = useSelector(settingsSelectors.ticketReminderVisible)
  const dispatch = useDispatch()
  const isInOperatorMode = useSelector(messagesSelectors.currentChatIsInOperatorMode)
  const isNoLogin = useIsAuthModeNoLogin()

  const onClickDismissHelp = useCallback(() => {
    dispatch(settingsActions.setTicketReminderVisible(false))
  }, [dispatch])

  return (
    <Transition
      show={ticketReminderVisible && !isInOperatorMode && !isNoLogin}
      className={'tw-mt-2'}
      enter="tw-transition-opacity tw-duration-300"
      enterFrom="tw-opacity-0"
      enterTo="tw-opacity-100"
      leave="tw-transition-opacity tw-duration-300"
      leaveFrom="tw-opacity-100"
      leaveTo="tw-opacity-0"
    >
      <div className="tw-flex tw-flex-row tw-items-end tw-space-x-1">
        <div
          className="tw-px-[10px] tw-py-[6px] tw-text-sm tw-rounded-[12px] tw-w-[100%]"
          style={{
            backgroundColor: 'var(--bot-msg-bg)',
            color: 'var(--bot-msg-text)',
            backdropFilter: 'blur(10px)',
          }}
        >
          <p className="tw-text-sm tw-m-0">{t('needToOpenTicket')}</p>
          <div className="tw-flex tw-gap-2 tw-mt-2.5 tw-mb-1">
            <UIButton
              size="sm"
              onClick={() => showOpenTicket()}
              style={{
                background: 'linear-gradient(167deg, var(--primary-gradient-start), var(--primary-gradient-end))',
              }}
            >
              {t('yes')}
            </UIButton>
            <UIButton size="sm" variant="secondary" onClick={onClickDismissHelp}>
              {t('no')}
            </UIButton>
          </div>
        </div>
      </div>
    </Transition>
  )
}
